var CalculatedPeriod = /** @class */ (function () {
    function CalculatedPeriod(source) {
        this.index = source.index;
        this.isLast = source.isLast;
        this.period = source.period;
        this.calculatedWin = source.calculatedWin;
        this.formatedWin = source.formatedWin;
        this.periodDurationInMilli = source.periodDurationInMilli;
        this.relativePercentFromTotal = source.relativePercentFromTotal;
        this.absolutePercentFromTotal = source.absolutePercentFromTotal;
        this.invertedStartTimeInMinutesFormat = source.invertedStartTimeInMinutesFormat;
        this.absoluteToGameFormattedGameStart = source.absoluteToGameFormattedGameStart;
        this.absoluteGameFormattedGameEnd = source.absoluteGameFormattedGameEnd;
        this.absoluteToGameStartInMilli = source.absoluteToGameStartInMilli;
        this.absoluteToGameEndInMilli = source.absoluteToGameEndInMilli;
        this.relativeRangeFormatted = source.relativeRangeFormatted;
        this.periodProgressState = source.periodProgressState;
    }
    return CalculatedPeriod;
}());
export { CalculatedPeriod };
//# sourceMappingURL=CalculatedPeriod.js.map